import { Card } from "antd";
import { useState } from "react";
import { cutDiscount } from "../../share/utils";

const AdsServiceCard = ({ data, isActive, onClick }) => {
  return (
    <>
      <Card
        className={` mt-0 ml-0 shadow-md w-full hover:cursor-pointer ${
          isActive ? "bg-primaryPurple" : ""
        }`}
        onClick={onClick}
      >
        <div className="mx-1">
          <div
            className={`text-lg mt-2 ${
              isActive ? "font-bold text-white truncate" : "font-bold truncate"
            }`}
          >
            {data?.serviceName ?? data?.serviceDetails?.serviceName}
          </div>
          <div className={`text-primaryPurple ${isActive ? "text-white" : ""}`}>
            {data?.offerType}
          </div>
          <div className="flex wrap">
            <div className="truncate">
              <p className={"text-primaryOrange  text-lg"}>
                ${data?.discountedPrice ?? data?.serviceDetails?.discountedPrice}
              </p>
            </div>
            <p
              className={`ml-1 text-lg hidden lg:block line-through ${
                isActive ? "text-white" : ""
              }`}
            >
              ${data?.servicePrice ?? data?.serviceDetails?.servicePrice}
            </p>
            <p
              className={` ml-auto rounded hidden lg:block mb-3 mt-2 px-1 ${
                isActive ? "bg-green text-white" : "bg-lightGreen text-green"
              }`}
            >
              {data?.discount ?? data?.serviceDetails?.discount}%
            </p>
          </div>
          <div className="flex">
            <p
              className={`text-lg mt-0 lg:hidden line-through ${
                isActive ? "text-white" : ""
              }`}
            >
              ${data?.servicePrice ?? data?.serviceDetails?.servicePrice}
            </p>
            <p
              className={` ml-auto rounded lg:hidden mt-0 px-1 ${
                isActive ? "bg-green text-white" : "bg-lightGreen text-green"
              }`}
            >
              {data?.discount ?? data?.serviceDetails?.discount}%
            </p>
          </div>
        </div>
      </Card>
    </>
  );
};
export default AdsServiceCard;
